export const PinIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1D1C1C"
    stroke-width="1.9"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M12 17v5"></path>
    <path d="M9 4h6l-1 6 3 3v1H7v-1l3-3z"></path>
  </svg>
);
